import React from "react";
import {observer} from 'mobx-react';
import classNames from "classnames";
import {GameInfo, OpenGameParameters} from '../../../../services/games/game-info';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {ILiveTableInfo} from '../../../../services/live-table-feeds-service/live-table-feeds.service.interface';
import {Check} from "@sparkware/app-utils";
import {LiveCasinoGridItemInfobarBox} from "./boxes/infobar/live-casino-grid-item-infobar.box";
import {LiveCasinoGridItemInfobarIconBox} from "./boxes/infobar/infobar-icon/live-casino-grid-item-infobar-icon.box";
import {LiveCasinoGridItemBetIntervalBox} from "./boxes/bet-interval/live-casino-grid-item-bet-interval.box";
import {LiveCasinoGridItemInfoItemBox} from "./boxes/infobar/info-item/live-casino-grid-item-info-item.box";
import {LiveCasinoGridItemClosedMessageBox} from "./boxes/closed-message/live-casino-grid-item-closed-message.box";
import {LiveCasinoGridItemThumbnailOverlayBox} from "./boxes/thumbnail/live-casino-grid-item-thumbnail-overlay.box";
import {LiveCasinoGridItemThumbnailBox} from "./boxes/thumbnail/live-casino-grid-item-thumbnail.box";
import {LiveCasinoGridItemWrapperBox} from "./boxes/wrapper/live-casino-grid-item-wrapper.box";
import {LiveCasinoGridItemBox} from "./boxes/grid-item/live-casino-grid-item.box";
import {ITEM_WRAPPER_BOX} from "./css-constants";
import {LiveCasinoGridItemThumbnailImageBox} from "./boxes/thumbnail/live-casino-grid-item-thumbnail-image.box";
import {LiveCasinoGridItemTitleBox} from "./boxes/title/live-casino-grid-item-title.box";
import {LiveCasinoGridItemBetBehindButtonBox} from "./boxes/infobar/bet-behind/live-casino-grid-item-bet-behind-button.box";
import {LiveCasinoGridItemJackpotBox} from "./boxes/infobar/jackpot/live-casino-grid-item-jackpot.box";
import {addQueryParam} from "../../../../../utils/url-utils";
import {LiveCasinoGridItemOpenAtBox} from "./boxes/closed-message/live-casino-grid-item-open-at.box";
import {TableSeatsComponent} from "./shared-components/table-seats.component";
import {RouletteDrawsComponent} from "./shared-components/roulette-draws.component";
import { FlexGrowItemBox } from "../../../../themes/architecture/css-helpers/flex";
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {withServices} from "../../../../react-hooks/with-services";

export interface ILiveCasinoArenaGridItemProps extends ComponentServicesPick<'jackpots'>{
  tableId: number;
  gameInfo: GameInfo;
  listTitle: string;
  gameIndex: number;
  seoCategory: string;
  liveTable: ILiveTableInfo;
  fluidWidth?: boolean;
  captureGameElementRef: (element: any) => void;
}

@observer
class ComponentBody extends OrbitComponent<ILiveCasinoArenaGridItemProps> {

    private _openGame = (gameInfo: GameInfo) => {
        const openGameParams: OpenGameParameters = {
            isRealMode: true,
            pageName: this.props.seoCategory,
            gameIndex: this.props.gameIndex,
            listTitle: this.props.listTitle
        };

        gameInfo.open(openGameParams);
    };

    private _renderMinMaxBet() {
        const tableInfo = this.props.liveTable;
        let minBet: number;
        let maxBet: number;
        if(Check.isEmpty(tableInfo) || (tableInfo.MinBet === undefined || tableInfo.MaxBet === undefined)) {
            minBet = this.props.gameInfo.minBet;
            maxBet = this.props.gameInfo.maxBet;
        } else {
            minBet = tableInfo.MinBet;
            maxBet = tableInfo.MaxBet;
        }

        if(!minBet || !maxBet){
            this.services.logger.info(`format$$$ invalid input for gameType => ${this.props.gameInfo.gameType} ${minBet}-${maxBet}`);
            return;
        }

        return (
            <LiveCasinoGridItemBetIntervalBox className='cy-live-casino-grid-item-bet-interval'>
          <span>
            {
                this.services.device.isMobile ?
                    this.services.currency.formatMoney(minBet, true) :
                    this.services.currency.formatMinMaxBet(minBet, maxBet)
            }
          </span>
            </LiveCasinoGridItemBetIntervalBox>
        );
    }

    private _renderDealerName() {

        const tableInfo = this.props.liveTable;
        const isMobilePhone = this.services.device.isMobile && !this.services.device.isTablet;

        if (Check.isEmpty(tableInfo) || Check.isNullOrUndefined(tableInfo.Dealer) || tableInfo.Dealer.length === 0 || isMobilePhone) {
            return null;
        }

        return (
            <LiveCasinoGridItemInfoItemBox className={'cy-live-casino-grid-item-infobar-dealer-name'}>
                <LiveCasinoGridItemInfobarIconBox alt={'Dealer_'+tableInfo.Dealer} src={this.services.theme.currentTheme.images.liveArena.dealerIcon.toString()}/>
                <span>{tableInfo.Dealer}</span>
            </LiveCasinoGridItemInfoItemBox>
        )
    }

    private _renderSeatsCount() {
        return <TableSeatsComponent tableInfo={this.props.liveTable}/>;
    }

    private _renderRouletteDraws() {
        return <RouletteDrawsComponent tableInfo={this.props.liveTable}/>;
    }

    private _renderJackpot() {
        let jpValue = this.props.jackpots.getGameJackpot(this.props.gameInfo.gameType);
        if (!Check.isNullOrUndefined(jpValue)) {
            return <LiveCasinoGridItemJackpotBox>
                { this.services.currency.formatMoney(jpValue) }
            </LiveCasinoGridItemJackpotBox>;
        }
        return null;
    }

    private _renderBetBehindButton() {
        const tableInfo = this.props.liveTable;
        let tableIsFull = false;
        if (tableInfo.Seats && tableInfo.SeatsTaken) {
            tableIsFull = tableInfo.SeatsTaken.length === tableInfo.Seats;
        }

        if (Check.isEmpty(tableInfo) || !tableInfo.BetBehind || !tableIsFull) {
            return null;
        }

        return (
            <LiveCasinoGridItemBetBehindButtonBox className="cy-live-casino-grid-item-infobar-bet-behind">
                <span>Bet behind</span>
            </LiveCasinoGridItemBetBehindButtonBox>
        );
    }

    private _renderGameInfobar() {

        const tableInfo = this.props.liveTable;

        if (Check.isEmpty(tableInfo) || !tableInfo.IsOpen) {
            return null;
        }

        return (
            <LiveCasinoGridItemInfobarBox className={'cy-live-casino-grid-item-infobar'}>
                {this._renderDealerName()}
                {this._renderSeatsCount()}
                <FlexGrowItemBox />
                {this._renderRouletteDraws()}
                {this._renderJackpot()}
                {this._renderBetBehindButton()}
            </LiveCasinoGridItemInfobarBox>
        );
    }

    private _renderGameIsClosed() {
        const tableInfo = this.props.liveTable;

        if (Check.isEmpty(tableInfo) || tableInfo.IsOpen) {
            return null;
        }

        return (
            <LiveCasinoGridItemClosedMessageBox className="cy-live-casino-grid-item-closed-message">
                <span>{this.services.translation.translate("LIVE_ARENA_TABLE_IS_CLOSED_MESSAGE")}</span>
                <LiveCasinoGridItemOpenAtBox className="cy-live-casino-grid-item-open-at">{this.props.liveTable?.OperationHoursStartTime}</LiveCasinoGridItemOpenAtBox>
            </LiveCasinoGridItemClosedMessageBox>
        );
    }

    private _renderGameThumbnailImage() {
        const tableInfo: ILiveTableInfo = this.props.liveTable;
        const gameInfo: GameInfo = this.props.gameInfo;
        let gameTitle: string;
        let gameImage: string;

        if (Check.isEmpty(tableInfo) || !tableInfo.TableImage) {
            gameTitle = gameInfo?.title;
            gameImage = gameInfo?.gameArenaIcon;
        } else {
            // We need this random because we want to force react to reload the image because the url of the image is identical but the image changed.
            let imageRandom = Math.random();

            gameTitle = tableInfo.Name;

            gameImage = addQueryParam(tableInfo.TableImage, imageRandom.toString());
        }

        return (<LiveCasinoGridItemThumbnailImageBox lazy src={gameImage} alt={gameTitle} className={'cy-live-casino-grid-item-thumbnail-image'}/>);
    }

    private _renderGameThumbnail() {
        return (
            <LiveCasinoGridItemThumbnailBox className="cy-live-casino-grid-item-thumbnail">
                {this._renderGameThumbnailImage()}
                <LiveCasinoGridItemThumbnailOverlayBox className="cy-live-casino-grid-item-thumbnail-overlay">
                    {this._renderMinMaxBet()}
                    {this._renderGameInfobar()}
                    {this._renderGameIsClosed()}
                </LiveCasinoGridItemThumbnailOverlayBox>
            </LiveCasinoGridItemThumbnailBox>
        );
    }

    private _renderGameTitle() {
        // Render an empty character so the div doesn't just collapse
        let title = this.props.gameInfo?.title || "\xa0";
        const tableInfo = this.props.liveTable;

        if (tableInfo && tableInfo.Name !== undefined && tableInfo.Name.length > 0) {
            title = tableInfo.Name;
        }

        return (
            <LiveCasinoGridItemTitleBox className="cy-live-casino-grid-item-title">
                <span>{title}</span>
            </LiveCasinoGridItemTitleBox>
        );
    }

    private _renderGameItem() {
        return (
            <LiveCasinoGridItemBox
                fluidWidth={this.props.fluidWidth}
                className={classNames(`cy-live-casino-grid-item`, `cy-live-casino-grid-item-${this.props.gameInfo.gameType}`,`game-type-${this.props.gameInfo.gameType}`)} ref={this.props.captureGameElementRef}
            >
                <LiveCasinoGridItemWrapperBox onClick={() => this._openGame(this.props.gameInfo)}  className={classNames('cy-live-casino-grid-item-inner-wrapper', ITEM_WRAPPER_BOX)}>
                    {this._renderGameThumbnail()}
                    {this._renderGameTitle()}
                </LiveCasinoGridItemWrapperBox>
            </LiveCasinoGridItemBox>
        );
    }

    render() {
        try {
            return this._renderGameItem();
        } catch(err) {
            this.services.logger.error(`Failed to render LiveCasinoArenaGridItem for game ${this.props.gameInfo && this.props.gameInfo.gameType}`, err);
            return null;
        }
    }
}

export const LiveCasinoArenaGridItem = withServices(ComponentBody, ['jackpots']);